module.exports = __webpack_public_path__ + "img/download_primary_button.cb7da80e.svg";